export default __webpack_public_path__ + "images/incognito.1b72adcccb8dacea86b3c8a522cce4e8.svg";